import { Button } from "@portal/BaseComponents/Button/AntButton";

import { ToolTip } from "@portal/BaseComponents/ToolTip/AntTooltip";
import { Icon } from "@portal/lib/icons/icons";
import { usePreviewAttachmentQuery } from "@portal/queries/download-query";
import { downLoadFileInDisk } from "@portal/util/save-file-in-disk";
import { useState } from "react";

interface DownloadProps {
  id: string;
  name: string;
  buttonProps?: React.ComponentProps<typeof Button>;
}

const t = {
  errorMessage: "Attachment's couldn't be downloaded!",
  download: "Download",
};

function DownloadDoc(props: DownloadProps) {
  const [url, setUrl] = useState<string>();
  const mutate = usePreviewAttachmentQuery();

  function handleClick() {
    if (url) return;
    mutate.mutateAsync(props.id).then((value) => {
      setUrl(value.expiry_link);
      downLoadFileInDisk(value.expiry_link, props.name);
    });
  }
  const DownloadIcon = (
    <Icon icon={["far", "download"]} color="var(--primary-7)" />
  );
  return (
    <ToolTip title={t.download}>
      <Button
        disabled={mutate.isLoading}
        onClick={handleClick}
        loading={mutate.isLoading}
        href={url}
        download={url}
        icon={DownloadIcon}
        target="_blank"
        {...props.buttonProps}
      />
    </ToolTip>
  );
}

export { DownloadDoc };
